import type { PoolOfferConfig } from '../../lib/api/operatorConsole';

/**
 * A fresh pack list with this page's own opening writes laid over it, plus the pinned pack
 * (the one being edited) carried over from the previous list when the read no longer has it.
 */
export function mergeReadPacks(
  read: PoolOfferConfig[],
  previous: PoolOfferConfig[],
  written: ReadonlyMap<number, PoolOfferConfig['animation']>,
  pinnedId: string,
): PoolOfferConfig[] {
  const merged = read.map((p) =>
    written.has(p.pool_offer_id) ? { ...p, animation: written.get(p.pool_offer_id) ?? null } : p,
  );
  if (!pinnedId || merged.some((p) => String(p.pool_offer_id) === pinnedId)) return merged;
  const kept = previous.find((p) => String(p.pool_offer_id) === pinnedId);
  return kept ? [...merged, kept] : merged;
}
